import { ComponentChild } from "preact";

import { useClasses } from "@styles";

interface TableProps {
  headers?: string[];
  content?: ComponentChild[][];
}

export function Table({
  headers = [],
  content = [],
}: TableProps) {
  return (<>
    <table className={useClasses("table")}>
      <thead>
        <tr>
          {headers.map((header, index) => (
            <th key={index}>{header}</th>
          ))}
        </tr>
      </thead>

      <tbody>
        {content.map((row, rowIndex) => (
          <tr key={rowIndex}>
            {row.map((cell, cellIndex) => (
              <td key={cellIndex}>{cell}</td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  </>);
}

